const renderBeltHighlight = ({
  sunOffsetX, 
  sunOffsetY, 
  outerR, innerR, 
  fill, textFill, 
  fontSize, 
  topScale, 
  bottomScale, 
  topLetterSpacing, 
  bottomLetterSpacing, 
  topText, bottomText, 
  topId, 
  bottomId, 
  bottomStartOffset = "50%",
}) => (
  <>
    <circle
      cx={-sunOffsetX}
      cy={sunOffsetY}
      r={outerR}
      fill={fill}
    />

    <circle
      cx={-sunOffsetX}
      cy={sunOffsetY}
      r={innerR}
      fill="black"
    />

    <defs>
      <path
        id={topId}
        d={`
          M ${-sunOffsetX - outerR * topScale} ${sunOffsetY}
          A ${outerR * topScale} ${outerR * topScale} 0 0 1
            ${-sunOffsetX + outerR * topScale} ${sunOffsetY}
        `}
      />

      <path
        id={bottomId}
        d={`
          M ${-sunOffsetX - outerR * bottomScale} ${sunOffsetY}
          A ${outerR * bottomScale} ${outerR * bottomScale} 0 0 0
            ${-sunOffsetX + outerR * bottomScale} ${sunOffsetY}
        `}
      />
    </defs>

    <text
      fill={textFill}
      fontSize={fontSize}
      fontWeight="600"
      letterSpacing={topLetterSpacing}
      textAnchor="middle"
    >
      <textPath href={`#${topId}`} startOffset="50%">
        {topText}
      </textPath>
    </text>

    <text
      fill={textFill}
      fontSize={fontSize}
      fontWeight="600"
      letterSpacing={bottomLetterSpacing}
      textAnchor="middle"
    >
      <textPath href={`#${bottomId}`} startOffset={bottomStartOffset}>
        {bottomText}
      </textPath>
    </text>
  </>
);

export default renderBeltHighlight;